/**
 * Subscription View Component
 * View for displaying and signing subscription agreement
 * Extracted from original lines 870-995
 */

import { FC } from "react";
import { Text, Center, Loader } from "@mantine/core";
import { ToastContainer } from "react-toastify";
import { Button } from "@funded-here-interface/common";
import DocViewer from "@cyntler/react-doc-viewer";
import { useStyle } from "../StructureNote.styles";
import { UI_TEXT, DOCUMENT_CONFIG } from "../StructureNote.constants";

interface SubscriptionViewProps {
  realUrl: string;
  documentId: number;
  completedAt: string;
  buttonDisabled: boolean;
  titleButton: string;
  regtankRequest: any;
  viewerKey: number;
  onSign: () => void;
  onBackToNotes: () => void;
}

/**
 * Subscription View container
 * Original logic from lines 870-995
 */
const SubscriptionView: FC<SubscriptionViewProps> = ({
  realUrl,
  documentId,
  completedAt,
  buttonDisabled,
  titleButton,
  regtankRequest,
  viewerKey,
  onSign,
  onBackToNotes,
}) => {
  const { classes } = useStyle();

  const docs = [
    {
      uri: realUrl,
      fileType: "pdf",
    },
  ];

  return (
    <div className={classes.SubscribeOutter}>
      {/* Header - shown only when not completed (lines 872-884) */}
      {completedAt === "" && (
        <div>
          <div className={classes.subscriptionAgreement}>
            <Text className={classes.aggrementTitle}>{UI_TEXT.AGREEMENT_TITLE}</Text>
          </div>
          <Text>{UI_TEXT.AGREEMENT_DESCRIPTION}</Text>
          <Text>{UI_TEXT.SUFFICIENT_FUNDS_WARNING}</Text>
        </div>
      )}

      {/* Header - shown when completed (lines 887-893) */}
      {completedAt !== "" && (
        <div className={classes.subscriptionAgreement}>
          <Text className={classes.aggrementTitle}>{UI_TEXT.AGREEMENT_TITLE}</Text>
        </div>
      )}

      <ToastContainer />

      {/* Document viewer and actions (lines 896-984) */}
      {realUrl !== "" && regtankRequest && (
        <>
          {/* PDF Document Viewer (lines 898-911) */}
          <DocViewer
            documents={docs}
            style={{ width: "100%", height: DOCUMENT_CONFIG.VIEWER_HEIGHT, overflow: "auto" }}
            className={classes.docviewer}
            key={viewerKey}
            config={{
              header: {
                disableHeader: false,
                disableFileName: true,
                retainURLParams: false,
              },
              pdfVerticalScrollByDefault: true,
            }}
          />

          {/* Action buttons when not completed (lines 913-929) */}
          {completedAt === "" && (
            <div className={classes.buttonContainer}>
              <Text style={{ marginBottom: "10px", fontSize: "14px" }}>
                {UI_TEXT.SIGN_ACKNOWLEDGEMENT}
              </Text>
              <Button
                onClick={onSign}
                disabled={buttonDisabled}
                textColor="white"
                backgroundColor="#338F86"
                children={UI_TEXT.PROCEED_TO_SIGN}
                title={titleButton}
              />
            </div>
          )}

          {/* Action buttons when completed (lines 931-940) */}
          {completedAt !== "" && (
            <div className={classes.buttonContainer}>
              <Button
                onClick={onBackToNotes}
                textColor="white"
                backgroundColor="#338F86"
                children={UI_TEXT.OKAY_BUTTON}
              />
            </div>
          )}
        </>
      )}

      {/* Loading state (lines 987-993) */}
      {realUrl === "" && (
        <div>
          <Center maw={400} h={500} mx="auto">
            <Loader />
          </Center>
        </div>
      )}
    </div>
  );
};

export default SubscriptionView;
